'use strict';

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Iframe from '../../IFrame';
import Loader from '../../Loader';
import Api from '../../../api/Api';
import Urls from '../../../definitions/Urls';
import iFrameNavigationListener from '../../../listener/iFrameNavigationListener';
import { QUESTIONNAIRES } from '../../../data/reducer';
import { getQuestionnaires } from '../../../data/questionnaires/actions';
import { setLastActive } from "../../../data/session/actions";

class CoronaQuestionnaire extends React.Component {
  constructor(props) {
    super(props);

    // initialize trusted context as empty
    this.state = { trustedContext: '', iframeStatus: null };
    this.queryBaseUrl =
      Urls.medixineApi() + '/signin-trustedcontext-fi?_trustedContextToken=';
  }

  componentDidMount() {
    // when component mounts, get recent trusted context.
    Api.getTrustedContext().then((ctx) => {
      this.setState({ trustedContext: ctx });
    });
    window.addEventListener('message', iFrameNavigationListener(this.props.setLastActive));
  }

  /*
   * When we move away from filling a carerequest, we do not know anything from it's state since it's in an iframe.
   * This is why we need to update/fetch new state of carerequests when we leave view. Questionnaires are handled
   * from the root component so the function is passed as props
   * */
  componentWillUnmount() {
    window.removeEventListener('message', iFrameNavigationListener);
  }

  iframeLoaded = () => {
    this.setState({ iframeStatus: 'loaded' });
  };

  render() {
    let { patientOID } = this.props.data;

    let url = this.state.trustedContext
      ? this.queryBaseUrl.concat(
          this.state.trustedContext,
          '&ReturnUrl=',
          encodeURIComponent(
            '/Q/covid19?PatientOID=' + patientOID + '&CreateCareRequest=true'
          )
        )
      : '';

    return (
      <div className="ot-mainview">
        {this.state.iframeStatus === null && <Loader />}
        <Iframe
          ref="frame"
          url={url}
          width="100%"
          height="1000px"
          display="initial"
          position="relative"
          allowFullScreen
          onLoad={() => this.iframeLoaded()}
        />
      </div>
    );
  }
}

CoronaQuestionnaire.propTypes = {
  match: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
  getQuestionnaires: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    data: state[QUESTIONNAIRES].data,
  };
};

export default connect(mapStateToProps, { getQuestionnaires, setLastActive })(
  CoronaQuestionnaire
);
